// extracted by mini-css-extract-plugin
module.exports = {"box":"AvgGradeBox-module--box--BhBCv","content":"AvgGradeBox-module--content--29r0j","bold":"AvgGradeBox-module--bold--2suVu"};